export default __webpack_public_path__ + "media/images/features/local_delivery/episode2/LP_07-3eff01f5995f9af032745132a1b42507.jpg";